export default "__VITE_ASSET__JmqYxYl5__"